const endpoints = {
	getDocumentsListing: '/documents/getDocumentsListing',
	setDocumentInfo: '/documents/setDocumentInfo'
}
export {endpoints}